import React from "react";
import bannerdipolma from "../../../../Assets/Courses/globalCourse.png";
const Farm = () => {
  return (
    <>
      <div className="w-full h-auto">
        <img
          src={bannerdipolma}
          alt="bannerdipolma"
          className="w-full h-full "
        />
      </div>
      <div className="w-full bg-white py-10 px-4 md:px-10">
        {/* Grid layout */}
        <div className="flex pb-10 flex-col md:flex-row gap-6">
          {/* Left Side (Scrollable Text Content) */}
          <div className="w-full md:w-[60%]">
            <h3 className="text-3xl md:text-4xl font-bold text-black mb-6 leading-snug">
              Top Institute For Diploma Courses{" "}
              <br className="hidden md:block" />
              Courses In Bhubaneswar
            </h3>

            <div className="text-gray-800 text-lg leading-relaxed text-justify space-y-6">
              <p>
                Despite the differences in the focus and goals of these three
                disciplines, Interior Design, Fashion Design and Graphic Design,
                each presents meaningful career opportunities for those who can
                master the skills required.
              </p>

              <p className="italic font-semibold text-gray-700">
                “The career opportunities at INSD Diploma Courses are so wide
                with international trend exposure.”
              </p>

              <div>
                <p className="font-semibold">Study in 4 different countries</p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>ONE INTERNATIONAL DEGREE</li>
                  <li>ONE INDIAN UGC APPROVED DEGREE</li>
                </ul>
              </div>

              <p>
                We will be giving our students a real-time study experience in 4
                different countries like Dubai, USA, Paris &amp; India.
              </p>

              <p>
                “International School of Design has established itself in arts,
                design, media and luxury education over the last 10 years. With
                our forward-thinking approach and innumerable foreign
                collaborations, INSD has successfully carved out a niche for
                itself. From over 55 city centre campuses across the nation that
                boast cutting-edge facilities, to an approach to teaching which
                saw us awarded best design school in India. Our reputation is
                well earned.”
              </p>

              <p>
                INSD Bhubaneswar has thrived as a Design School, developing a
                national reputation as an innovative and creative academic
                community, with a firm commitment to offering vocational
                practice-based courses that provide students the space to
                develop their skills and pursue their passion.
              </p>

              <p>
                We're proud to announce a ONE-OF-ITS-KIND Global program that
                will truly put our students on the world map. An opportunity to
                study and live in 4 countries in 4 years is what will make our
                students international.
              </p>

              <h5 className="text-2xl font-bold text-gray-900 mt-10">
                Career Paths After Diploma Courses
              </h5>

              <p>
                This enables the design aspirants studying Fashion, Interiors,
                and Graphic to travel to 3 different countries while pursuing
                their 4 years of Global Design Degree.
              </p>

              <ul className="list-disc list-inside ml-4 space-y-1">
                <li>4 Year Program</li>
                <li>Study in 4 Countries</li>
                <li>Intern for 3 months</li>
                <li>Dual-Degree (French + Indian)</li>
                <li>Be a global designer</li>
                <li>Learn from Global Design Expert</li>
              </ul>
            </div>
          </div>

          {/* Right Side (Sticky Video) */}
          <div className="w-full md:w-[40%] h-fit md:sticky md:top-24 self-start">
            <div className="aspect-video rounded-lg overflow-hidden shadow-lg">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/mPxxhZxmdO0?si=SdSrILi-hbNOZACX"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
        <div className="bg-gradient-to-br from-gray-50 to-blue-50 py-12 ">
          {/* Heading Section */}
          <div className="mx-auto text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4 heading">
              Career Paths
            </h2>
            <p className="text-lg text-gray-600 sub-heading">
              Explore the exciting opportunities that await you
            </p>
          </div>

          {/* Card Section */}
          <div className="w-full mx-auto flex flex-col lg:flex-row gap-8 items-stretch">
            {/* Left Column */}
            <div className="w-full">
              <div className="p-8 h-full">
                <h3 className="text-2xl font-bold text-[#144982] mb-6 border-b-4 border-[#DA3335] pb-3 inline-block heading">
                  Your Future Awaits
                </h3>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sub-heading">
                  {/* Card 1 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#144982] to-[#1a5a9e] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#DA3335] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          UI / UX Designer
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 2 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#DA3335] to-[#ff4547] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#144982] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          UX Researcher
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 3 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#144982] to-[#1a5a9e] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#DA3335] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          UI/UX Developer
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 4 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#DA3335] to-[#ff4547] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#144982] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          UX Strategist
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 5 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#144982] to-[#1a5a9e] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#DA3335] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          UX Consultant
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 6 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#DA3335] to-[#ff4547] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#144982] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          Service Designer
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 7 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#144982] to-[#1a5a9e] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#DA3335] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          UX Consultant
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 8 */}
                  <div className="group">
                    <div className="bg-gradient-to-r from-[#DA3335] to-[#ff4547] text-white p-4 rounded-lg shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#144982] rounded-full mr-3"></div>
                        <span className="font-semibold text-sm">
                          Product Designer
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Farm;
